import styled from 'styled-components';

export const PersonalProfileSC = styled.div`
  max-width: 808px;

  .ui-textfield,
  .ui-select,
  .ui-textarea {
    width: 100%;
  }

  .first-section {
    margin-top: 0px;
  }
`;
